import IconWorkPlace from '@/shared/uikit/assets/icons/IconWorkPlace.svg?react';
import IconParkingPlace from '@/shared/uikit/assets/icons/IconParkingPlace.svg?react';
import IconMeetingRoomCircle from '@/shared/uikit/assets/icons/IconMeetingRoomCircle.svg?react';
import IconWorkParkingBoth from '@/shared/uikit/assets/icons/IconWorkParkingBoth.svg?react';
import IconDeviceLaptop from '@/shared/uikit/assets/icons/IconDeviceLaptop.svg?react';
import IconCone from '@/shared/uikit/assets/icons/IconCone.svg?react';
import IconMeetingRoom from '@/shared/uikit/assets/icons/IconMeetingRoom.svg?react';
import IconNetworkError from '@/shared/uikit/assets/icons/IconNetworkError.svg?react';
import { BookingType } from '@/shared/types/bookingObjects.types';
import { Group } from '@mantine/core';

type UseGetBookingTypeDataProps = {
	bookingType: BookingType;
	className?: string;
};

export const useGetBookingTypeData = ({ bookingType, className }: UseGetBookingTypeDataProps) => {
	const getBookingData = (type: BookingType) => {
		switch (type) {
			case 'work_place':
				return {
					label: 'Рабочее место',
					iconCard: <IconWorkPlace className={className} />,
					icon: <IconDeviceLaptop fontSize={24} />,
					type,
				};

			case 'parking_place':
				return {
					label: 'Парковка',
					iconCard: <IconParkingPlace className={className} />,
					icon: <IconCone fontSize={24} />,
					type,
				};

			case 'meeting_room':
				return {
					label: 'Переговорная',
					iconCard: <IconMeetingRoomCircle className={className} />,
					icon: <IconMeetingRoom fontSize={24} />,
					type,
				};

			case 'work_park':
				return {
					label: 'Рабочее место и парковка',
					iconCard: <IconWorkParkingBoth className={className} />,
					icon: (
						<Group gap="xs">
							<IconDeviceLaptop fontSize={24} />
							<IconCone fontSize={24} />
						</Group>
					),
					loading: 0,
					type,
				};

			default:
				return {
					label: 'Нет данных',
					iconCard: <IconNetworkError className={className} />,
					icon: <IconNetworkError fontSize={24} />,
					type,
				};
		}
	};
	return getBookingData(bookingType);
};
